export const TRANSLATIONS_NB = {
  heroText: 'Finn din neste destinasjon',
  searchPlaces: ' Søk steder',
  home: 'Hjem',
  places: 'Steder',
  contact: 'Kontakt',
  admin: 'Admin',
  login: 'Logg inn',
  logout: 'Logg ut',
  mostPopular: 'Mest populære',
  mostPopularText: 'Våre mest populære steder',
  cabins: 'Hytter',
  apartments: 'Leiligheter',
  hotels: 'Hoteller',
  viewPlaces: 'Vis steder',
  allTypes: 'Alle typer',
  order: 'Bestill',
  userReviews: 'Brukeranmeldelser',
  leaveReview: 'Skriv en anmeldelse',
  rating: 'Vurdering',
  name: 'Navn',
  reviewText: 'Anmeldelse',
  publish: 'Publiser',
  showMore: 'Vis mer',
  showLess: 'Vis mindre',
  urlCopied: 'URL kopiert til utklippstavlen',
  fullName: 'Fullt Navn',
  guests: 'Gjester',
  checkIn: 'Sjekk inn',
  checkOut: 'Sjekk ut',
  close: 'Lukk',
  sendingOrder: 'Sender bestilling...',
  sendOrder: 'Send bestilling',
  nameHere: 'Navn her',
  reviewTextHere: 'Anmeldelse tekst her',
  message: 'Melding',
  messageHere: 'Din melding her',
  welcome: 'Velkommen',
  orders: 'Bestillinger',
  inbox: 'Innboks',
  view: 'Vis',
  createNewPlace: 'Opprett nytt sted',
  totalOrder: 'Totale bestillinger',
  totalPlaces: 'Totale steder',
  ordered: 'Bestilt',
  deleteItem: 'Er du sikker på at du vil slette dette elementet?',
  created: 'Opprettet',
  messages: 'meldinger',
  from: 'Fra',
  sent: 'Sendt',
  placeName: 'Steds navn',
  imageUrl: 'Bilde URL',
  placeType: 'Steds type',
  price: 'Pris',
  description: 'Beskrivelse',
  descriptionText: 'Beskrivelse her',
  create: 'Opprett',
  creating: 'Oppretter...',
  chooseType: 'Velg en type',
  choosePrice: 'Velg en pris',
  usernameOrEmail: 'Brukernavn eller email',
  password: 'Passord',
  signingIn: 'Logger inn...',
  signInNow: 'Logg inn nå',
  wrongPassword: 'Ugyldig brukernavn eller passord',
  copyright: 'Copyright 2021 © Holidaze Alle rettigheter forbeholdt.',
  norwegian: 'Norsk (Norwegian)',
  english: 'Engelsk (English) ',
  noResult: 'Ingen resultat...',
  searchOrder: 'Søk i bestillinger (sted, navn og ID)',
  pageNotFound: 'Side ikke funnet',
  orderError: 'Noe gikk galt...',
  confirmOrder: 'Bestillingen ble sendt',
  createPlaceError: 'Noe gikk galt med å opprettet sted...',
  confirmCreatePlace: 'Stedet ble opprettet',
  sendingError: 'Noe gikk galt under sending...',
  messageSent: 'Meldingen ble sendt',
};
